<div class="auth-wrapper">
  <mat-card class="auth-card" appearance="outlined">
    <mat-card-content class="auth-content">
      <h1 class="headline">{{ 'device.headline' | transloco }}</h1>

      @switch (state) {
        @case ('enter-code') {
          <p class="supporting">{{ 'device.enterCode.supporting' | transloco }}</p>
          <form (submit)="onSubmit($event)">
            <app-code-entry
              [length]="codeLength"
              mode="alphanumeric"
              [groupSize]="codeGroup"
              [initialValue]="prefill"
              [ariaLabel]="'device.enterCode.label' | transloco"
              [cellLabel]="'device.enterCode.charLabel' | transloco: {n: '{n}', total: '{total}'}"
            />
            <button mat-flat-button color="primary" type="submit" [disabled]="!codeComplete()">
              {{ 'device.enterCode.submit' | transloco }}
            </button>
          </form>
        }

        @case ('sign-in-required') {
          <div class="device-loading" role="status" aria-live="polite">
            <mat-spinner diameter="40"></mat-spinner>
            <p class="supporting">{{ 'device.signInRequired' | transloco }}</p>
          </div>
        }

        @case ('loading') {
          <div class="device-loading" role="status" aria-live="polite">
            <mat-spinner diameter="40"></mat-spinner>
          </div>
        }

        @case ('connecting') {
          <div class="device-loading" role="status" aria-live="polite">
            <mat-spinner diameter="40"></mat-spinner>
            <p class="supporting">{{ 'device.connecting' | transloco: {appName: appName} }}</p>
          </div>
        }

        @case ('approved') {
          <p class="supporting success" role="status">{{ 'device.approved' | transloco: {appName: appName} }}</p>
        }

        @case ('access-denied') {
          <p class="error" role="alert">{{ 'device.accessDenied' | transloco: {appName: appName} }}</p>
        }

        @case ('error') {
          <p class="error" role="alert">{{ 'device.error' | transloco }}</p>
        }
      }
    </mat-card-content>
  </mat-card>
</div>
